class SliderComponentExtended extends HTMLElement {
	constructor() {
		super();
		this.slider = this.querySelector('.swiper-js');

		if (!this.slider) return;

		this.wrapperEL = this.slider.querySelector('.swiper-wrapper-js');
		this.slideELs = this.slider.querySelectorAll('.swiper-slide-js');
		this.swiper = null;

		// Controls
		this.scrollbarEL = this.slider.querySelector('.swiper-scrollbar');
		this.nextEL = this.slider.querySelector('.swiper-button-next');
		this.prevEL = this.slider.querySelector('.swiper-button-prev');
		this.paginationEL = this.slider.querySelector('.swiper-pagination');


		this.ifEnabled();

		const resizeObserver = new ResizeObserver((entries) => this.ifEnabled());
		resizeObserver.observe(this.slider);
	}

	ifEnabled() {
		if (this.slider.dataset.mobileSwiper == 'true') {
			this.initSlider();
		}
	}

	initSlider() {
		let vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);

		if (vw < 750) {
			this.slider.classList.add('swiper');

			this.wrapperEL.classList.remove('row', 'row-cols-1', 'row-cols-sm-2', 'row-cols-md-1', 'row-cols-md-2', 'row-cols-md-3', 'row-cols-md-4', 'row-cols-md-5');
			this.wrapperEL.classList.add('swiper-wrapper');

			// this.scrollbarEL.classList.add('swiper-scrollbar');

			this.slideELs.forEach(function (slideEL) {
				slideEL.className = '';
				slideEL.classList.add('swiper-slide');
			});

			this.swiper = new Swiper(this.slider, {
				scrollbar: {
					el: this.scrollbarEL,
					draggable: true,
				},
				navigation: {
					nextEl: this.nextEL,
					prevEl: this.prevEL,
				},
				pagination: {
					el: this.paginationEL,
					type: 'fraction',
				},
			});
		} else {
			if (this.swiper) {
				this.swiper.destroy();

				this.slider.classList.remove('swiper');
				const wrapperEL_classes = this.wrapperEL.dataset.classes.split(' ');
				this.wrapperEL.classList.add(...wrapperEL_classes);

				this.wrapperEL.classList.remove('swiper-wrapper');
				// this.scrollbarEL.classList.remove('swiper-scrollbar');
				this.slideELs.forEach(function (slideEL) {
					slideEL.className = '';
					slideEL.classList.add('swiper-slide-js');
					const slideEL_classes = slideEL.dataset.classes.split(' ');
					slideEL.classList.add(...slideEL_classes);
				});
			} 
		}
	}
}

customElements.define('slider-component-extended', SliderComponentExtended);
